module.exports = __webpack_public_path__ + "static/img/product_lassi.e2c85dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_lassi.png
// module id = BkAA
// module chunks = 1